// To generate a new file similar to this one, run `pay js:run gql-v1 --type=fragment --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {SharedToken} from '@stripe-internal/data-v1/types';

import type {
  Exact,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionNetworkEnum,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionProviderEnum,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionTypeEnum,
  OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionVerificationStateEnum,
  OpenapiCryptocurrencyPayinsResourceCryptoPayinSessionStateEnum,
  OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum,
  OpenapiCryptocurrencyPayinsResourceSupportedCurrencyCurrencyNetworkEnum,
  Scalars,
  OpenapiCryptocurrencyPayinsResourceExternalPaymentDetailsExternalPaymentPartnerEnum,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  fragment PayinSessionFragment on OpenapiCryptocurrencyPayinsResourceCryptoPayinSession {
    id
    livemode
    merchant
    consumer_account
    payment_details {
      amount
      currency
      payauthz_id
      return_url
      original_amount
      original_currency
    }
    transaction_details {
      wallet_address
      blockchain_tx_id
      destination_address
      destination_currency
      destination_network
      destination_amount
      state
      solana_latest_blockhash
      solana_destination_token_account_address
    }
    external_payment_details {
      payment_id
      payment_url
      payment_qr_code
      external_payment_partner
    }
    state
    settlement_partner
    deposit_addresses_do_not_fund_directly
    spender_contract_addresses
    feature_flags {
      enable_crypto_payins_off_session_payments
      use_async_confirmation_flow
      enable_crypto_payins_pay_from_exchange
      enable_crypto_payins_direct_deposit
      enable_underpayment_detection
      enable_gasless_v2
      enable_smart_contract_wallet_detection
      crypto_payins_generic_payment_title
      enable_pay_with_any_crypto
    }
    supported_currencies {
      id
      asset_display_name
      asset_code
      currency_minor_units
      currency_symbol
      currency_network
      mainnet
      contract_address
      chain_id
    }
    business_name
    logo_url
    client_secret
    nonce
    valid_before
    valid_after
    disabled_wallet_providers
    setup_future_usage
    has_succeeded_or_processing_setup_attempt
    max_relay_request_status
    wallet_sessions {
      id
      livemode
      merchant
      address
      connected
      network
      provider
      type
      verification_state
      challenge {
        domain
        address
        uri
        version
        chain_id
        nonce
        issued_at
        scheme
        statement
        expiration_time
        not_before
        request_id
        resources
      }
    }
    active_wallet {
      id
      livemode
      merchant
      address
      connected
      network
      verification_state
      challenge {
        domain
        address
        uri
        version
        chain_id
        nonce
        issued_at
        scheme
        statement
        expiration_time
        not_before
        request_id
        resources
      }
    }
    consumer_wallet
    customer_email
    merchant_branding {
      background_color
      button_color
    }
    underpayment_transfers {
      received_amount
      currency
    }
  }
`;

export const payinSessionFragment: PayinSessionFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type PayinSessionFragmentData = {
  readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinSession';
  readonly id: string;
  readonly livemode: boolean;
  readonly merchant: string;
  readonly consumer_account: string | null;
  readonly state: OpenapiCryptocurrencyPayinsResourceCryptoPayinSessionStateEnum;
  readonly settlement_partner: string;
  readonly deposit_addresses_do_not_fund_directly: Scalars['JSONObject'];
  readonly spender_contract_addresses: Scalars['JSONObject'] | null;
  readonly business_name: string | null;
  readonly logo_url: string | null;
  readonly client_secret: string;
  readonly nonce: string;
  readonly valid_before: string;
  readonly valid_after: string;
  readonly disabled_wallet_providers: ReadonlyArray<string> | null;
  readonly setup_future_usage: boolean;
  readonly has_succeeded_or_processing_setup_attempt: boolean;
  readonly max_relay_request_status: string | null;
  readonly consumer_wallet: string | null;
  readonly customer_email: string | null;
  readonly payment_details: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourcePaymentDetails';
    readonly amount: number;
    readonly currency: string;
    readonly payauthz_id: string;
    readonly return_url: string;
    readonly original_amount: number | null;
    readonly original_currency: string | null;
  };
  readonly transaction_details: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceTransactionDetails';
    readonly wallet_address: string | null;
    readonly blockchain_tx_id: string | null;
    readonly destination_address: string | null;
    readonly destination_currency: string | null;
    readonly destination_network: string | null;
    readonly destination_amount: string | null;
    readonly state: string | null;
    readonly solana_latest_blockhash: string | null;
    readonly solana_destination_token_account_address: string | null;
  } | null;
  readonly external_payment_details: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceExternalPaymentDetails';
    readonly payment_id: string;
    readonly payment_url: string;
    readonly payment_qr_code: string;
    readonly external_payment_partner: OpenapiCryptocurrencyPayinsResourceExternalPaymentDetailsExternalPaymentPartnerEnum;
  } | null;
  readonly feature_flags: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinsFlags';
    readonly enable_crypto_payins_off_session_payments: boolean;
    readonly use_async_confirmation_flow: boolean;
    readonly enable_crypto_payins_pay_from_exchange: boolean;
    readonly enable_crypto_payins_direct_deposit: boolean;
    readonly enable_underpayment_detection: boolean;
    readonly enable_gasless_v2: boolean;
    readonly enable_smart_contract_wallet_detection: boolean;
    readonly crypto_payins_generic_payment_title: boolean;
    readonly enable_pay_with_any_crypto: boolean;
  };
  readonly supported_currencies: ReadonlyArray<{
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceSupportedCurrency';
    readonly id: string;
    readonly asset_display_name: string;
    readonly asset_code: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum;
    readonly currency_minor_units: number;
    readonly currency_symbol: string | null;
    readonly currency_network: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyCurrencyNetworkEnum;
    readonly mainnet: boolean;
    readonly contract_address: string;
    readonly chain_id: number;
  }>;
  readonly wallet_sessions: ReadonlyArray<{
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceConsumerWalletSession';
    readonly id: string;
    readonly livemode: boolean;
    readonly merchant: string;
    readonly address: string;
    readonly connected: boolean;
    readonly network: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionNetworkEnum;
    readonly provider: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionProviderEnum | null;
    readonly type: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionTypeEnum | null;
    readonly verification_state: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionVerificationStateEnum;
    readonly challenge: {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceWalletVerificationChallenge';
      readonly domain: string;
      readonly address: string;
      readonly uri: string;
      readonly version: string;
      readonly chain_id: number;
      readonly nonce: string;
      readonly issued_at: string;
      readonly scheme: string | null;
      readonly statement: string | null;
      readonly expiration_time: string | null;
      readonly not_before: string | null;
      readonly request_id: string | null;
      readonly resources: ReadonlyArray<string> | null;
    };
  }>;
  readonly active_wallet: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceConsumerWalletSession';
    readonly id: string;
    readonly livemode: boolean;
    readonly merchant: string;
    readonly address: string;
    readonly connected: boolean;
    readonly network: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionNetworkEnum;
    readonly verification_state: OpenapiCryptocurrencyPayinsResourceConsumerWalletSessionVerificationStateEnum;
    readonly challenge: {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceWalletVerificationChallenge';
      readonly domain: string;
      readonly address: string;
      readonly uri: string;
      readonly version: string;
      readonly chain_id: number;
      readonly nonce: string;
      readonly issued_at: string;
      readonly scheme: string | null;
      readonly statement: string | null;
      readonly expiration_time: string | null;
      readonly not_before: string | null;
      readonly request_id: string | null;
      readonly resources: ReadonlyArray<string> | null;
    };
  } | null;
  readonly merchant_branding: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceMerchantBranding';
    readonly background_color: string | null;
    readonly button_color: string | null;
  } | null;
  readonly underpayment_transfers: ReadonlyArray<{
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceUnderpaymentTransfer';
    readonly received_amount: number;
    readonly currency: string;
  }> | null;
};

export type PayinSessionFragmentVariables = Exact<{[key: string]: never}>;

export type PayinSessionFragmentToken = SharedToken<{}>;

export type PayinSessionFragmentDocument = GraphQlDocument<
  PayinSessionFragmentData,
  PayinSessionFragmentVariables,
  PayinSessionFragmentToken
>;
